import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noWhiteSpace(errorText: string = 'Write a character'): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const isWhitespace = (control.value || '').trim().length === 0;
    if (!isWhitespace) {
      return null;
    }

    if (isWhitespace) {
      return {
        description: errorText,
        code: '300',
      };
    }

    return null;
  };
}
